import { DateZone, MarketHours, MarketPeriod } from '@oai-frontend-monorepo/types';
import { DateTime } from 'luxon';
import { mapHolidays, shortDays } from './mapHolidays';

export const deriveMarketPeriod = (
  marketHours?: MarketHours,
  currentTime = DateTime.utc().setZone(DateZone.New_York)
): MarketPeriod | undefined => {
  // check if its a weekend
  const isWeekend = currentTime.weekday > 5;

  if (isWeekend) {
    return MarketPeriod.MARKET_CLOSED;
  }

  // check if its a holiday
  const holidays = mapHolidays(marketHours);

  const isHoliday = holidays?.[currentTime.toFormat('yyyy-MM-dd')];

  if (isHoliday) {
    return MarketPeriod.MARKET_CLOSED; // assume quote close price remains until 3am EST of the next trading day
  }

  let expiryTime = 16;

  if (shortDays[currentTime.toFormat('yyyy-MM-dd') as keyof typeof shortDays]) {
    expiryTime = 13;
  }

  const marketOpen = DateTime.utc()
    .setZone(DateZone.New_York)
    .startOf('day')
    .plus({ hour: 9, minute: 30 });

  const marketClose = DateTime.utc()
    .setZone(DateZone.New_York)
    .startOf('day')
    .plus({ hour: expiryTime });

  if (currentTime < marketOpen) {
    return MarketPeriod.PRE_MARKET;
  }

  if (currentTime >= marketClose) {
    return MarketPeriod.AFTER_MARKET;
  }

  return MarketPeriod.REGULAR_MARKET;
};
